import store from "../store";

export default [
  {
    path: "*",
    meta: {
      public: true,
    },
    redirect: {
      path: "/404",
    },
  },
  {
    path: "/404",
    meta: {
      public: true,
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      ),
  },
  {
    path: "/test",
    meta: { breadcrumb: true, title: "Test" },
    name: "Test",
    component: () => import("@/views/Test"),
  },

  {
    path: "/login",
    meta: {
      public: true,
    },
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      ),
    beforeEnter(to, from, next) {
      if (store.state.user) next("Requests");
      else next();
    },
  }, 
  {
    path: "/reset-password",
    meta: { breadcrumb: true, title: "Reset Password" },
    name: "Reset Password",
    component: () => import("@/views/ResetPassword"),
  }, 
  {
    path: "/reset-password-email",
    meta: { breadcrumb: true, title: "Reset Password" },
    name: "Reset Password",
    component: () => import("@/views/ResetPasswordEmail"),
  },
  {
    path: "",
    meta: { breadcrumb: true },
    name: "Root",
    async beforeEnter(to, from, next) {
      await store.dispatch("validateToken");
      if (!store.state.user) next(`login?next=${to.name}`);
      else {
        await store.dispatch("initTwilioConnection");
        await store.dispatch("initSocket");
        // Landing on the root path: route by permission using the freshly
        // validated permissions (not the stale ones in localStorage).
        if (to.name === "Root") {
          const canDispatch =
            store.state.user.permissions &&
            store.state.user.permissions.includes("DISPATCHING");
          next({ name: canDispatch ? "Requests" : "Captains" });
        } else {
          next();
        }
      }
    },
    component: () => import("@/components/RootComponent"),
    children: [
      // {
      //     path: '/operator_kpi',
      //     meta: { breadcrumb: true, title: "Operator KPI" },
      //     name: "OperatorKPI",
      //     component: () => import("@/views/CompetitiveCharts")
      // },
      // {
      //     path: '/cancellation_table',
      //     meta: { breadcrumb: true, title: "Cancellation Table" },
      //     name: "CancellationTable",
      //     component: () => import("@/views/CancellationTable")
      // },
      {
        path: "/debug_view",
        meta: { breadcrumb: true, title: "Debug View" },
        name: "Debug View",
        component: () => import("@/views/DebugView"),
      },
      // {
      //     path: '/lateness',
      //     meta: { breadcrumb: true, title: 'Lateness' },
      //     name: 'Lateness',
      //     component: () => import('@/views/monitoring/Lateness')
      // },
      {
        path: "/notifications",
        meta: { breadcrumb: true, title: "Notifications" },
        name: "AllNotifications",
        component: () => import("@/views/AllNotifications"),
      },
      {
        path: "/available_interview_times",
        meta: { breadcrumb: true, title: "Available Interview Times" },
        name: "AvailableInterviewTimes",
        component: () =>
          import("@/views/driver_acquisition/AvailableInterviewTimes"),
      },
      {
        path: "/interviews",
        meta: { breadcrumb: true, title: "Interviews" },
        name: "Interviews",
        component: () => import("@/views/driver_acquisition/Interviews"),
      },
      {
        path: "/dashboard",
        meta: { breadcrumb: true, title: "Dashboard" },
        name: "Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "routes" */
            `@/views/Dashboard`
          ),
      },
      // {
      //   path: "/timeline",
      //   meta: { breadcrumb: true, title: "Timeline" },
      //   name: "Timeline",
      //   component: () => import("@/views/dispatching/Timeline"),
      // },
      {
        path: "/requests",
        meta: { breadcrumb: true, title: "Requests" },
        name: "Requests",
        beforeEnter(to, from, next) {
          const user = store.state.user;
          const canDispatch =
            user && user.permissions && user.permissions.includes("DISPATCHING");
          if (canDispatch) next();
          else next({ name: "Captains" });
        },
        component: () => import("@/views/dispatching/Requests"),
      },
      {
        path: "/path_drawer",
        meta: { breadcrumb: true, title: "Path Drawer" },
        name: "PathDrawer",
        component: () => import("@/views/monitoring/PathDrawer"),
      },
      {
        path: "/rides_tracker",
        meta: { breadcrumb: true, title: "Map" },
        name: "RidesTracker",
        component: () => import("@/views/monitoring/RidesTracking"),
      },
      // {
      //     path: "/ai_stats",
      //     meta: { breadcrumb: true, title: "AiStats" },
      //     name: "AiStats",
      //     component:
      //         () => import("@/views/monitoring/AiStats")
      // },
      {
        path: "/staff",
        meta: { breadcrumb: true, title: "Staff" },
        name: "Staff",
        component: () => import("@/views/users/List"),
      },
      {
        path: "/staff/add",
        meta: { breadcrumb: true, title: "Staff" },
        name: "Staff Creation",
        component: () => import("@/views/users/AddStaff"),
      },
      {
        path: "/hotels",
        meta: { breadcrumb: true, title: "Hotels" },
        name: "Hotels",
        component: () => import("@/views/hotels/HotelsN"),
      },
      {
        path: "/hotels/store",
        meta: { breadcrumb: true, title: "HotelsCreate" },
        name: "Hotels Create",
        component: () => import("@/views/hotels/CreateHotelN"),
      },
      {
        path: "/hotels/edit/:id",
        meta: { breadcrumb: true, title: "Edit Hotel" },
        name: "EditHotel",
        component: () => import("@/views/hotels/EditHotel"),
      },
      {
        path: "/hotelsUsers",
        meta: { breadcrumb: true, title: "Users" },
        name: "HotelsUsers",
        component: () => import("@/views/hotels/Hotels"),
      },
      {
        path: "/restaurants",
        meta: { breadcrumb: true, title: "Users" },
        name: "Restaurants",
        component: () => import("@/views/restaurants/RestaurantsN"),
      },
      {
        path: "/restaurants/store",
        meta: { breadcrumb: true, title: "RestaurantsCreate" },
        name: "Restaurants Create",
        component: () => import("@/views/restaurants/CreateRestaurantN"),
      },
      {
        path: "/restaurants/edit/:id",
        meta: { breadcrumb: true, title: "Edit Restaurant" },
        name: "EditRestaurant",
        component: () => import("@/views/restaurants/EditRestaurant"),
      },
      {
        path: "/restaurantsUsers",
        meta: { breadcrumb: true, title: "Users" },
        name: "RestaurantsUsers",
        component: () => import("@/views/restaurants/Restaurants"),
      },
      {
        path: "/companies",
        meta: { breadcrumb: true, title: "Users" },
        name: "Companies",
        component: () => import("@/views/companies/Companies"),
      },
      {
        path: "/company-requests",
        meta: { breadcrumb: true, title: "CompanyRequests" },
        name: "CompanyRequests",
        component: () => import("@/views/company_requests/CompanyRequests"),
      },
      {
        path: "/company-request/:id",
        meta: { breadcrumb: true, title: "Company Request" },
        name: "CompanyRequest",
        component: () => import("@/views/company_requests/Profile"),
      },
      {
        path: "/hotels/create",
        meta: { breadcrumb: true, title: "Users" },
        name: "Hotels Create",
        component: () => import("@/views/hotels/CreateHotel"),
      },
      {
        path: "/restaurants/create",
        meta: { breadcrumb: true, title: "Users" },
        name: "Create Restaurant ",
        component: () => import("@/views/restaurants/CreateRestaurant"),
      },
      {
        path: "/companies/create",
        meta: { breadcrumb: true, title: "Users" },
        name: "Create Company ",
        component: () => import("@/views/companies/CreateCompany"),
      },

      // {
      //     path: '/unresolved_leaves',
      //     meta: { breadcrumb: true, title: "Unresolved Leaves" },
      //     name: 'UnresolvedLeaves',
      //     component: () => import("@/views/Leave/UnresolvedLeaves")
      // },
      // {
      //     path: '/unresolved_extra_hours',
      //     meta: { breadcrumb: true, title: "UnresolvedExtraHours" },
      //     name: 'UnresolvedExtraHours',
      //     component: () => import("@/views/extra_hours/UnresolvedExtraHours")
      // },
      // {
      //     path: '/salary_reports',
      //     meta: { breadcrumb: true, title: "Salary Reports" },
      //     name: 'SalariesReports',
      //     // props: true,
      //     props: route => ({
      //         date: route.query.date,
      //         user_id: route.query.user_id,
      //         regenrate_option: (String(route.query.regenrate_option).toLowerCase() === 'true'),
      //         //  regenrate_option: route.query.regenrate_option,
      //         enable_employee_choose: (String(route.query.enable_employee_choose).toLowerCase() === 'true')
      //         //  enable_employee_choose: route.query.enable_employee_choose
      //     }),
      //     component: () => import("@/views/HRAccounting/SalaryReportIndex")
      // },
      // {
      //     path: '/salaries_reports',
      //     meta: { breadcrumb: true, title: "Salary Reports" },
      //     name: 'AllSalariesReports',
      //     component: () => import("@/views/HRAccounting/AllSalaryReportsIndex")
      // },
      // {
      //     path: '/employment_type',
      //     meta: { breadcrumb: true, title: "EmploymentTypes" },
      //     name: 'EmploymentTypes',
      //     component: () => import("@/views/HRAccounting/EmploymentTypes")
      // },
      // {
      //     path: '/salary_event',
      //     meta: { breadcrumb: true, title: "SalaryEvents" },
      //     name: 'SalaryEvents',
      //     component: () => import("@/views/HRAccounting/SalaryEvents")
      // },
      // {
      //     path: '/employment_type/:id/delay_policies',
      //     name: 'DelayPolices',
      //     meta: { breadcrumb: true, title: 'DelayPolices' },
      //     component: () => import("@/views/HRAccounting/DelayPolicies")
      // },
      // {
      //     path: '/employment_type/:id/general_holidays',
      //     name: 'GeneralHolidays',
      //     meta: { breadcrumb: true, title: 'General Holidays' },
      //     component: () => import("@/views/HRAccounting/GeneralHolidays")
      // },
      // {
      //     path: '/project_schedule',
      //     meta: { breadcrumb: true, title: "User Project Schedule" },
      //     name: 'UserProjectScheduleCalendar',
      //     component: () => import("@/views/UserProjectScheduleCalendar")
      // },
      // {
      //     path: '/users/:id',
      //     meta: { breadcrumb: true, title: "User Profile" },
      //     name: 'UserProfile',
      //     component: () => import("@/views/users/Profile")
      // },
      {
        path: "/users/:id",
        meta: { breadcrumb: true, title: "User Profile" },
        name: "UserProfile",
        component: () => import("@/views/users/StaffProfile"),
      },
      {
        path: "/unregistered_passengers",
        meta: { breadcrumb: true, title: "UnregisteredPassengers" },
        name: "UnregisteredPassengers",
        component: () => import("@/components/monaco/UnregisteredِِAgent"),
        props: { provider: "passengers" },
      },
      {
        path: "/passengers",
        meta: { breadcrumb: true, title: "Passengers" },
        name: "Passengers",
        component: () => import("@/views/passengers/Passengers"),
      },
      {
        path: "/unregistered_captains",
        meta: { breadcrumb: true, title: "UnregisteredCaptains" },
        name: "UnregisteredCaptains",
        component: () => import("@/components/monaco/UnregisteredِِAgent"),
        props: { provider: "captains" },
      },
      {
        path: "/captains",
        meta: { breadcrumb: true, title: "Captains" },
        name: "Captains",
        component: () => import("@/views/captains/Captains"),
      },
      {
        path: "/tickets_monitoring",
        meta: { breadcrumb: true, title: "Tickets Monitoring" },
        name: "TicketsMonitoring",
        component: () =>
          import("@/views/customer_care/ticketing/TicketsMonitoring"),
      },
      {
        path: "/car_requests",
        meta: { breadcrumb: true, title: "CarRequests" },
        name: "CarRequests",
        component: () => import("@/views/captains/CarRequests"),
      },
      // {
      //     path: "/phone_vouchers",
      //     meta: { breadcrumb: true, title: "PhoneVouchers" },
      //     name: "PhoneVouchers",
      //     component: () => import("@/views/phone_vouchers/List")
      // },
      {
        path: "/vouchers",
        meta: { breadcrumb: true, title: "Vouchers" },
        name: "Vouchers",
        component: () => import("@/views/vouchers/List"),
      },
      {
        path: "/vouchers/add",
        meta: { breadcrumb: true, title: "VouchersEditor" },
        name: "VouchersEditor",
        component: () => import("@/views/vouchers/Editor"),
      },
      // {
      //     path: "/demand_pump/create",
      //     meta: { breadcrumb: true, title: "VoucherDemandPumpCreate" },
      //     name: "VoucherDemandPumpCreate",
      //     component: () => import("@/views/vouchers/DemandPump/Create")
      // },
      // {
      //     path: "/demand_pump/index",
      //     meta: { breadcrumb: true, title: "VoucherDemandPumpIndex" },
      //     name: "VoucherDemandPumpIndex",
      //     component: () => import("@/views/vouchers/DemandPump/Index")
      // },
      {
        path: "/vouchers/:id",
        meta: { breadcrumb: true, title: "VouchersEditor" },
        name: "VoucherDetails",
        component: () => import("@/views/vouchers/Editor"),
      },
      {
        path: "/rating_causes",
        name: "RatingCauses",
        meta: { breadcrumb: true, title: "Rating Causes" },
        component: () => import("@/views/customer_support/RatingCauses"),
      },
      // {
      //     path: '/first_ride_pax',
      //     name: 'FirstRidePax',
      //     meta: { breadcrumb: true, title: 'First Ride Pax' },
      //     component: () => import("@/views/customer_support/FirstRidePax")
      // },
      {
        path: "/bonus_package",
        name: "Bonus Package",
        meta: { breadcrumb: true, title: "Bonus Packages" },
        component: () => import("@/views/BonusPackage/Index"),
      },
      {
        path: "/bonus_package/:id",
        name: "Bonus Package Details",
        meta: { breadcrumb: true, title: "Bonus Package" },
        component: () => import("@/views/BonusPackage/Details"),
      },
      {
        path: "/bonus_package/:id/bonuses",
        name: "Bonuses",
        meta: { breadcrumb: true, title: "Bonuses" },
        component: () => import("@/views/BonusPackage/Bonuses"),
      },
      {
        path: "/bonus/:id/time_slices",
        name: "Bonus Time Slices",
        meta: { breadcrumb: true, title: "Bonus Time Slices" },
        component: () => import("@/views/BonusPackage/BonusTimeSlices"),
      },
      {
        path: "/conditional_bonus",
        name: "Anas",
        meta: { breadcrumb: true, title: "Anas" },
        component: () => import("@/views/customer_support/Anas"),
      },
      {
        path: "/services",
        name: "Services",
        meta: { breadcrumb: true, title: "Services" },
        component: () => import("@/views/services/List"),
      },
      {
        path: "/services/:id/prices",
        name: "ServicePrices",
        meta: { breadcrumb: true, title: "ServicePrices" },
        component: () => import("@/views/services/Prices"),
      },
      // {
      //     path: "user-settings",
      //     name: "UserSettings",
      //     meta: { breadcrumb: true, title: "User Settings" },
      //     component: () => import("@/views/users/Settings")
      // },
      {
        path: "/services/:id/locations",
        name: "ServiceLocations",
        meta: { breadcrumb: true, title: "Service Locations" },
        component: () => import("@/views/services/Locations"),
      },
      {
        path: "/services/:id/cars",
        name: "ServiceCars",
        meta: { breadcrumb: true, title: "ServiceCars" },
        component: () => import("@/views/services/Cars"),
      },
      // {
      //     path: "/notification_centre",
      //     name: "NotificationCentre",
      //     meta: { breadcrumb: true, title: "NotificationCentre" },
      //     component: () => import("@/views/NotificationCentre")
      // },

      {
        path: "/car_brands",
        name: "CarBrands",
        meta: { breadcrumb: true, title: "CarBrands" },
        component: () => import("@/views/types/CarBrands"),
      },
      // {
      //     path: "/weekly_present_captains",
      //     name: "WeeklyPresentCaptains",
      //     meta: { breadcrumb: true, title: "Weekly Present Captains" },
      //     component: () => import("@/views/captains/WeeklyPresent")
      // },
      {
        path: "/colors",
        name: "Colors",
        meta: { breadcrumb: true, title: "Colors" },
        component: () => import("@/views/types/Colors"),
      },
      {
        path: "/banks",
        name: "Banks",
        meta: { breadcrumb: true, title: "Banks" },
        component: () => import("@/views/types/Banks"),
      },
      {
        path: "/BarStatistics",
        name: "BarStatistics",
        meta: { breadcrumb: true, title: "BarStatistics" },
        component: () => import("@/views/Statistics"),
      },
      {
        path: "/monaco_editor",
        name: "MonacoEditor",
        meta: { breadcrumb: true, title: "Monaco Editor" },
        component: () => import("@/views/MonacoEditor"),
      },
      {
        path: "/map_editor",
        name: "MapEditor",
        meta: { breadcrumb: true, title: "Map Editor" },
        component: () => import("@/views/MapEditor"),
      },
      {
        path: "/nationalities",
        name: "Nationalities",
        meta: { breadcrumb: true, title: "Nationalities" },
        component: () => import("@/views/types/Nationalities"),
      },
      {
        path: "/car_brands/:id/models",
        name: "CarBrandModels",
        meta: { breadcrumb: true, title: "CarBrandModels" },
        component: () => import("@/views/types/CarBrandModels"),
      },
      {
        path: "/location_containers",
        name: "LocationContainers",
        meta: { breadcrumb: true, title: "Location Containers" },
        component: () => import("@/views/locations/ContainerList"),
      },
      {
        path: "/location_containers/add",
        name: "LocationContainersAdder",
        meta: { breadcrumb: true, title: "Add Location Container" },
        component: () => import("@/views/locations/ContainerEditor"),
      },
      {
        path: "/location_containers/:id",
        name: "LocationContainerEditor",
        meta: { breadcrumb: true, title: "Edit Location Container" },
        component: () => import("@/views/locations/ContainerEditor"),
      },
      {
        path: "/landmarks",
        name: "Landmarks",
        meta: { breadcrumb: true, title: "Landmarks" },
        component: () => import("@/views/locations/LandmarkList"),
      },
      {
        path: "/stations",
        name: "stations",
        meta: { breadcrumb: true, title: "Stations" },
        component: () => import("@/views/locations/StationList"),
      },
      {
        path: "/stations/add",
        name: "StationsAdder",
        meta: { breadcrumb: true, title: "Add Station" },
        component: () => import("@/views/locations/StationEditor"),
      },
      {
        path: "/landmarks/add",
        name: "LandmarksAdder",
        meta: { breadcrumb: true, title: "Add Landmark" },
        component: () => import("@/views/locations/LandmarkEditor"),
      },
      {
        path: "/sectors",
        name: "Sectors",
        meta: { breadcrumb: true, title: "Sectors" },
        component: () => import("@/views/locations/Sectors"),
      },
      {
        path: "/landmarks/:id",
        name: "LandmarksEditor",
        meta: { breadcrumb: true, title: "Edit Landmark" },
        component: () => import("@/views/locations/LandmarkEditor"),
      },
      {
        path: "/rides/:id",
        name: "Rides",
        meta: { breadcrumb: true, title: "Rides" },
        component: () => import("@/views/RidePage"),
      },
      {
        path: "/SeasonalDestinations/update",
        name: "EditSeasonalDestinations",
        meta: { breadcrumb: true, title: "Update Seasonal Destinations" },
        component: () => import("@/views/area/EditClusters"),
      },
      // {
      //     path: "/get_qr_code",
      //     name: "GetQrCode",
      //     meta: { breadcrumb: true, title: "QR Code" },
      //     component: () => import("@/views/GetQrCode")
      // },
      {
        path: "/VehicleTypesManagement",
        name: "VehicleTypesManagement",
        meta: { breadcrumb: true, title: "Vehicle Type" },
        component: () => import("@/views/types/VehicleType"),
      },
      {
        path: "contract_template/level",
        meta: { breadcrumb: true, title: "Levels" },
        name: "Level",
        component: () => import("@/views/contract_template/Level"),
      },
      // {
      //     path: '/advertising_campaign',
      //     meta: { breadcrumb: true, title: "Advertising Campaign" },
      //     name: 'AdvertisingCampaign',
      //     component: () => import("@/views/advertising_campaign/AdvertisingCampaign")
      // },
      {
        path: "/change_captain_reasons",
        meta: { breadcrumb: true, title: "Change-captain Reasons" },
        name: "ChangeCaptainReasons",
        component: () =>
          import("@/views/change_captain_reasons/ChangeCaptainReasons"),
      },
      {
        path: "/contract_template",
        meta: { breadcrumb: true, title: "Contract Template" },
        name: "contract_template",
        component: () => import("@/views/contract_template/ContractTemplate"),
      },
      {
        path: "/stations/:id",
        name: "StationsEditor",
        meta: { breadcrumb: true, title: "Edit Station" },
        component: () => import("@/views/locations/StationEditor"),
      },
      {
        path: "/contract_template",
        meta: { breadcrumb: true, title: "Contract Template" },
        name: "contract_template",
        component: () => import("@/views/contract_template/ContractTemplate"),
      },
      {
        path: "/landmarks/:id",
        name: "LandmarksEditor",
        meta: { breadcrumb: true, title: "Edit Landmark" },
        component: () => import("@/views/locations/LandmarkEditor"),
      },
      // {
      //     path: "user_schedule",
      //     name: "UserSchedule",
      //     meta: { breadcrumb: true, title: "User Schedule" },
      //     component: () => import("@/views/UserSchedule")
      // },
      {
        path: "/restricted-areas",
        name: "RestrictedAreas",
        meta: {
          breadcrumb: true,
          title: "Restricted Areas",
        },
        component: () => import("@/views/locations/RestrictedAreas"),
      },
      {
        path: "/restricted-areas/add",
        name: "RestrictedAreasAdder",
        meta: {
          breadcrumb: true,
          title: "Add Restricted Area"
        },
        component: () => import("@/views/locations/RestrictedAreaEditor"),
      },
      {
        path: "/restricted-areas/:id",
        name: "RestrictedAreasEditor",
        meta: {
          breadcrumb: true,
          title: "Edit Restricted Area"
        },
        component: () => import("@/views/locations/RestrictedAreaEditor"),
      },
       {
        path: "/dispatching-polygon",
        name: "DispachingPolygon",
        meta: {
          breadcrumb: true,
          title: "Dispaching Polygon",
        },
        component: () => import("@/views/locations/DispatchingPolygonEditor"),
      },
      {
        path: "/locations",
        name: "Locations",
        meta: {
          breadcrumb: true,
          title: "Locations",
          props: { blacklist: false },
        },
        component: () => import("@/views/locations/List"),
      },
      {
        path: "/locations/add",
        name: "LocationsAdder",
        meta: {
          breadcrumb: true,
          title: "Add Location",
          props: { blacklist: false },
        },
        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/locations/:id",
        name: "LocationsEditor",
        meta: {
          breadcrumb: true,
          title: "Edit Location",
          props: { blacklist: false },
        },
        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/blacklist_locations",
        name: "BlacklistLocations",
        meta: { breadcrumb: true, title: "Locations" },
        props: { blacklist: true },
        component: () => import("@/views/locations/List"),
      },
      {
        path: "/blacklist_locations/add",
        name: "BlacklistLocationsAdder",
        meta: { breadcrumb: true, title: "Add Location" },
        props: { blacklist: true },

        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/blacklist_locations/:id",
        name: "BlacklistLocationsEditor",
        meta: { breadcrumb: true, title: "Edit Location" },
        props: { blacklist: true },
        component: () => import("@/views/locations/Editor"),
      },
      {
        path: "/roles",
        name: "Roles",
        meta: { breadcrumb: true, title: "Roles" },
        component: () => import("@/views/users/Roles"),
      },
      {
        path: "/passengers/:id",
        meta: { breadcrumb: true, title: "Passenger Profile" },
        name: "PassengerProfile",
        component: () => import("@/views/passengers/Profile"),
      },
      // {
      //     path: "/captain/performance",
      //     meta: { breadcrumb: true, title: "Captain Performance" },
      //     name: "CaptainPerformance",
      //     component: () => import("@/views/captains/Performance")
      // },
      // {
      //     path: "/captain/acceptance-ratio",
      //     meta: { breadcrumb: true, title: "Acceptance Ratio" },
      //     name: "CaptainAcceptanceRatio",
      //     component: () => import("@/views/captains/AcceptanceRatio")
      // },
      // {
      //     path: "/suggestion_allowed_captain",
      //     meta: { breadcrumb: true, title: "Suggestion Allowed Captain" },
      //     name: "SuggestionAllowedCaptains",
      //     component: () => import("@/views/captains/SuggestionAllowed")
      // },
      // {
      //     path: "/lost_captains",
      //     meta: { breadcrumb: true, title: "Lost Captain" },
      //     name: "LostCaptains",
      //     component: () => import("@/views/captains/Lost")
      // },
      // {
      //     path: '/captains/:id',
      //     meta: { breadcrumb: true, title: "Captain Profile" },
      //     name: 'CaptainProfile',
      //     component: () => import("@/views/captains/Profile")
      // },
      {
        path: "/captains/:id",
        meta: { breadcrumb: true, title: "Captain Profile" },
        name: "CaptainProfile",
        component: () => import("@/views/captains/CaptainProfile"),
      },
      {
        path: "/captains/:id/monthly-bookings",
        meta: { breadcrumb: true, title: "Captain Profile Bookings" },
        name: "CaptainProfile",
        component: () => import("@/views/captains/CaptainsStatusesTimeline"),
      },
      {
        path: "/drivers/map",
        meta: { breadcrumb: true, title: "Captains Map" },
        name: "CaptainsMap",
        component: () => import("@/views/tracking/CaptainsMap"),
      },
      {
        path: "/announcements/",
        meta: { breadcrumb: true, title: "Drivers announcements" },
        name: "DriversAnnouncements",
        component: () => import("@/views/announcements/SendAnnouncements"),
      },
      {
        path: "/drivers/create",
        meta: { breadcrumb: true, title: "Create new driver" },
        name: "CreateCaptain",
        component: () => import("@/views/captains/CreateCaptain"),
      },
      {
        path: "/drivers/:id/createCar",
        meta: { breadcrumb: true, title: "Create new car" },
        name: "CreateCaptainCar",
        component: () => import("@/views/captains/CreateCaptainCar"),
      },
      {
        path: "/captain_cancellation_reasons",
        meta: { breadcrumb: true, title: "Captain Cancellation Reasons" },
        name: "CaptainCancellationReasons",
        component: () => import("@/views/captain_cancellation_reasons"),
      },
      // {
      //     path: '/accounting/transactions',
      //     meta: { breadcrumb: true, title: "Transactions" },
      //     name: 'Transactions',
      //     component: () => import("@/views/accounting/Transactions")
      // },
      // {
      //     path: '/accounting/captain/payments',
      //     meta: { breadcrumb: true, title: "Payments" },
      //     name: 'Payments',
      //     component: () => import("@/views/accounting/Payments")
      // },
      // {
      //     path: '/accounting/captain_balance',
      //     meta: { breadcrumb: true, title: "Captain Balance" },
      //     name: 'Captain Balance',
      //     component: () => import("@/views/accounting/CaptainBalance")
      // },
      // {
      //     path: '/accounting/captain/payments/:id',
      //     meta: { breadcrumb: true, title: "Report" },
      //     name: 'Report',
      //     component: () => import("@/views/accounting/Payment")
      // },
      // {
      //     path: '/setting',
      //     meta: { breadcrumb: true, title: "Setting" },
      //     name: 'Setting',
      //     component: () => import("@/views/Setting")
      // },
      {
        path: "/settings",
        meta: { breadcrumb: true, title: "Settings" },
        name: "Settings",
        component: () => import("@/views/Settings"),
      },
      {
        path: "/dispatching",
        meta: { breadcrumb: true, title: "Settings" },
        name: "Dispatching",
        component: () => import("@/views/Dispatching"),
      },
      {
        path: "/reservations",
        meta: { breadcrumb: true, title: "Reservations" },
        name: "ReservationsList",
        component: () => import("@/views/ReservationsList"),
      },
      {
        path: "/blockedCaptains",
        meta: { breadcrumb: true, title: "Auto Regulation" },
        name: "BlockedCaptains",
        component: () => import("@/views/BlockedCaptains"),
      },
      {
        path: "/events/report",
        meta: { breadcrumb: true, title: "Reservations" },
        name: "EventsReport",
        component: () => import("@/views/EventsReport"),
      },
      // {
      //   path: "/testComponent",
      //   meta: { breadcrumb: true, title: "testComponent" },
      //   name: "testComponent",
      //   component: () => import("@/views/testComponent"),
      // },
      {
        path: "/shifts/map",
        meta: { breadcrumb: true, title: "ShiftsMap" },
        name: "ShiftsMap",
        component: () => import("@/views/planning/ShiftsMap"),
      },
      {
        path: "/testMaps",
        meta: { breadcrumb: true, title: "testMaps" },
        name: "testMaps",
        component: () => import("@/views/planning/testMaps"),
      },
      {
        path: "/events",
        meta: { breadcrumb: true, title: "Events" },
        name: "Events",
        component: () => import("@/views/planning/Events"),
      },
      {
        path: "reservation_queue",
        meta: { breadcrumb: true, title: "ReservationQueue" },
        name: "ReservationQueue",
        component: () => import("@/views/reservationQueue/ReservationQueue"),
      },
      {
        path: "/shifts",
        meta: { breadcrumb: true, title: "Shifts" },
        name: "Shifts",
        component: () => import("@/views/shifts/Shifts"),
      },
      {
        path: "/terms_and_conditions",
        meta: { breadcrumb: true, title: "TermsAndConditions" },
        name: "TermsAndConditions",
        component: () => import("@/views/termsAndConditions/TermsAndConditions"),
      },
      {
        path: "/terms_and_conditions/create",
        meta: { breadcrumb: true, title: "CreateTermsAndConditions" },
        name: "CreateTermsAndConditions",
        component: () => import("@/views/termsAndConditions/CreateTermsAndConditions"),
      },
      {
        path: "/events/create",
        meta: { breadcrumb: true, title: "CreateEvent" },
        name: "CreateEvent",
        component: () => import("@/views/planning/CreateEvent"),
      },
      {
        path: "/events/:id",
        meta: { breadcrumb: true, title: "Event Details" },
        name: "EventDetails",
        component: () => import("@/views/planning/EventDetails"),
      },
      {
        path: "/broadcast",
        meta: { breadcrumb: true, title: "Broadcast" },
        name: "Broadcast",
        component: () => import("@/views/Broadcast"),
      },
      {
        path: "/monitor",
        meta: { breadcrumb: true, title: "Monitor" },
        name: "Monitor",
        component: () => import("@/views/monitoring/Monitor"),
      },
      {
        path: "/rides_search",
        meta: { breadcrumb: true, title: "RidesSearch" },
        name: "RidesSearch",
        component: () => import("@/views/monitoring/RidesSearch"),
      },
      {
        path: "/messages",
        meta: { title: "Messages" },
        name: "Messages",
        component: () => import("@/views/Messages"),
      },
      {
        path: "/log/:id",
        meta: { breadcrumb: true, title: "Booking Log" },
        name: "BookingLog",
        component: () => import("@/views/BookingLog"),
      },
      {
        path: "/booking-chat/:id",
        meta: { breadcrumb: true, title: "Booking Chat" },
        name: "BookingChat",
        component: () => import("@/views/BookingChat/BookingChat"),
      },
      {
        path: "/phone-bookings",
        meta: { breadcrumb: true, title: "Phone booking" },
        name: "PhoneBooking",
        component: () => import("@/views/dispatching/PhoneBooking"),
      },
      {
        path: "/surveys",
        meta: { breadcrumb: true, title: "Surveys" },
        name: "Surveys",
        component: () => import("@/views/surveys/surveys"),
      },
      {
        path: "/survey/:id",
        meta: { breadcrumb: true, title: "Survey" },
        name: "Survey",
        component: () => import("@/views/surveys/survey"),
      },
      {
        path: "/surveys/create",
        meta: { breadcrumb: true, title: "Create Surveys" },
        name: "CreateSurvey",
        component: () => import("@/views/surveys/CreateSurvey"),
      },
      {
        path: "/constraints",
        meta: { breadcrumb: true, title: "Constraints" },
        name: "Constraints",
        component: () => import("@/views/constraints/Constraints"),
      },
      {
        path: "/auth_logs",
        meta: { breadcrumb: true, title: "Auth Logs" },
        name: "AuthLogs",
        component: () => import("@/views/auth_logs/AuthLogs"),
      },
      {
        path: "/constraints/create",
        meta: { breadcrumb: true, title: "Create Constraint" },
        name: "CreateConstraint",
        component: () => import("@/views/constraints/CreateConstraint"),
      },
      {
        path: "/constraints/edit/:id",
        meta: { breadcrumb: true, title: "Edit Constraint" },
        name: "EditConstraint",
        component: () => import("@/views/constraints/EditConstraint"),
      },
      {
        path: "/priceRules",
        meta: { breadcrumb: true, title: "Price Rules" },
        name: "PriceRules",
        component: () => import("@/views/priceRules/PriceRules"),
      },
      {
        path: "/priceRules/edit/:id",
        meta: { breadcrumb: true, title: "Edit Price Rule" },
        name: "EditPriceRules",
        component: () => import("@/views/priceRules/EditPriceRules"),
      },
      {
        path: "/priceRules/create",
        meta: { breadcrumb: true, title: "Create Price Rule" },
        name: "CreatePriceRules",
        component: () => import("@/views/priceRules/CreatePriceRules"),
      },
      {
        path: "/complaints",
        meta: { breadcrumb: true, title: "Complaints List" },
        name: "ComplaintsList",
        component: () =>
          import("@/views/customer_care/complaints/ComplaintsList"),
      },
      {
        path: "/vacations",
        meta: { breadcrumb: true, title: "vacations" },
        name: "Vacations",
        component: () =>
          import("@/views/Vacations"),
      },
      {
        path: "/scheduled_messages",
        meta: { breadcrumb: true, title: "Global Messages" },
        name: "scheduled_messages",
        component: () => import("@/views/global_messages/GlobalMessages"),
      },
      {
        path: "/scheduled_messages/store",
        meta: { breadcrumb: true, title: "Global Messages" },
        name: "create_scheduled_messages",
        component: () => import("@/views/global_messages/CreateGlobalMessage"),
      },
      {
        path: "/MaxBookingCount",
        meta: { breadcrumb: true, title: "MaxBookingCount" },
        name: "MaxBookingCount",
        component: () =>
          import("@/views/MaxBookingCount"),
      },
      {
        path: "/seasonal_reservations",
        meta: { breadcrumb: true, title: "Seasonal drivers reservations allowance special cases" },
        name: "seasonal_drivers_reservations_allowance_special_cases",
        component: () => import("@/views/seasonal_reservations/SeasonalReservations"),
      },
      {
        path: "/payments",
        meta: { breadcrumb: true, title: "Payments" },
        name: "payments",
        component: () => import("@/views/payments/Payments"),
      },
      {
        path: "/seasonal_reservations/store",
        meta: { breadcrumb: true, title: "Create seasonal drivers reservations allowance" },
        name: "create_seasonal_drivers_reservations_allowance",
        component: () => import("@/views/seasonal_reservations/CreateSeasonalReservation"),
      },
      {
        path: "/seasonal_reservations/edit/:id",
        meta: { breadcrumb: true, title: "Edit seasonal drivers reservations allowance " },
        name: "edit_seasonal_drivers_reservations_allowance",
        component: () => import("@/views/seasonal_reservations/EditSeasonalReservation"),
      },
      {
        path: "/sms_codes",
        meta: { breadcrumb: true, title: "SMS Codes" },
        name: "sms_codes",
        component: () => import("@/views/sms_codes/SmsCodes"),
      },
      {
        path: "/captain_complaints_no_booking/:id",
        meta: { breadcrumb: true, title: "Captain Complaints" },
        name: "captain_complaints",
        component: () => import("@/views/captain_complaints_no_booking/CaptainComplaintsNoBooking"),
      },
      {
        path: "/lost_and_found",
        meta: { breadcrumb: true, title: "Lost And Found" },
        name: "lost_and_found",
        component: () => import("@/views/lost_and_found/LostAndFound"),
      },
       {
        path: "/lost_and_found/store",
        meta: { breadcrumb: true, title: "New Lost And Found" },
        name: "create_lost_and_found",
        component: () => import("@/views/lost_and_found/CreateLostAndFound"),
      },
      {
        path: "/lost_and_found/edit/:id",
        meta: { breadcrumb: true, title: "Edit Lost And Found" },
        name: "edit_lost_and_found",
        component: () => import("@/views/lost_and_found/EditLostAndFound"),
      },
       {
        path: "/special_events",
        meta: { breadcrumb: true, title: "Special Events" },
        name: "special_events",
        component: () => import("@/views/special_events/SpecialEvents"),
      },
       {
        path: "/special_events/store",
        meta: { breadcrumb: true, title: "New Special Event" },
        name: "create_special_events",
        component: () => import("@/views/special_events/CreateSpecialEvent"),
      },
      {
        path: "/special_events/edit/:id",
        meta: { breadcrumb: true, title: "Edit Special Event" },
        name: "edit_special_events",
        component: () => import("@/views/special_events/EditSpecialEvent"),
      },
      // {
      //     path: '/customer_care/tickets_management',
      //     meta: { breadcrumb: true, title: "TicketsManagement" },
      //     name: 'TicketsManagement',
      //     component: () => import("@/views/customer_care/ticketing/TicketsManagement")
      // },
      // {
      //     path: "/customer_care/tickets",
      //     meta: { breadcrumb: true, title: "Tickets" },
      //     name: "Tickets",
      //     component: () => import("@/views/customer_support/Tickets")
      // },
      // {
      //     path: '/customer_care/tickets/:id',
      //     meta: { breadcrumb: true, title: "Ticket" },
      //     name: 'Ticket',
      //     component: () => import("@/views/customer_care/ticketing/Ticket")
      // },
      // {
      //     path: '/money_transfer',
      //     meta: {breadcrumb: true, title: "Money Transfer"},
      //     name: "MoneyTransfer",
      //     component: () => import("@/views/MoneyTransfer")
      // },
      // {
      //     path: '/airport/create',
      //     meta: {breadcrumb: true, title: "Create"},
      //     name: 'AirportCreate',
      //     component: () => import("@/views/Airport/create")
      // },
      // {
      //     path: '/airport/index',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'AirportIndex',
      //     component: () => import("@/views/Airport/Index")
      // },
      // {
      //     path: '/market/create',
      //     meta: {breadcrumb: true, title: "Create"},
      //     name: 'MarketCreate',
      //     component: () => import("@/views/Market/create")
      // },
      // {
      //     path: '/market/index',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'MarketIndex',
      //     component: () => import("@/views/Market/Index")
      // },
      // {
      //     path: '/beesline/area_clusters',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'BeeslineAreaClusters',
      //     component: () => import("@/views/beesline/AreaClusters")
      // },
      // {
      //     path: '/beesline/setting',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'BeeslineSettings',
      //     component: () => import("@/views/beesline/BeeslineSetting")
      // },
      // {
      //     path: '/promoter_page',
      //     meta: {breadcrumb: true, title: "PromoterPage"},
      //     name: 'PromoterPage',
      //     component: () => import("@/views/PromoterPage")
      // },
      // {
      //     path: "/beesline/check_voucher",
      //     meta: {breadcrumb: true, title: "Beesline - Check Voucher"},
      //     name: "CheckBeesLineVoucher",
      //     component: () => import("@/views/beesline/CheckVoucher")
      // },
      // {
      //     path: '/beesline/area_clusters',
      //     meta: {breadcrumb: true, title: "Index"},
      //     name: 'BeeslineAreaClusters',
      //     component: () => import("@/views/beesline/AreaClusters")
      // },
      // {
      //     path: "/beesline/stores",
      //     meta: {breadcrumb: true, title: "Beesline - Stores"},
      //     name: "BeeslineStores",
      //     component: () => import("@/views/beesline/Stores")
      // },
      // {
      //     path: "/beesline/statistics",
      //     meta: {breadcrumb: true, title: "Beesline - Statistics"},
      //     name: "BeeslineStatistics",
      //     component: () => import("@/views/beesline/Statistics")
      // },
      // {
      //     path: '/accounting/cash_register',
      //     meta: { breadcrumb: true, title: "Cash Registers" },
      //     name: 'Cash Registers',
      //     component: () => import("@/views/accounting/cash_register/Index")
      // },
      // {
      //     path: '/accounting/cash_register/:id',
      //     meta: { breadcrumb: true, title: "Cash Register" },
      //     name: 'Cash Register',
      //     component: () => import("@/views/accounting/cash_register/CashRegister")
      // },
      // {
      //     path: '/accounting/pending_transactions',
      //     meta: { breadcrumb: true, title: "PendingTransactions" },
      //     name: 'Pending Transactions',
      //     component: () => import("@/views/accounting/cash_register/PendingTransactions")
      // },
      // {
      //     path: '/accounting/bonus_requests',
      //     meta: { breadcrumb: true, title: "Bonus Requests" },
      //     name: 'Bonus Requests',
      //     component: () => import("@/views/accounting/BonusRequests")
      // }
    ],
  },
];
